import styled from "styled-components";
import { Select, Slider, Tabs } from "antd";
import { ReactComponent as Search } from "../../assets/icons/search.svg";
import { ReactComponent as Return } from "../../assets/icons/return.svg";

const { TabPane } = Tabs;
const { Option } = Select;

export const Wrap = styled.div`
  display: flex;
  margin: 100px 200px;
`;

export const Filter = styled.div`
  display: flex;
  max-height: 100vh;
  flex: 1;
  margin-right: 45px;
  padding: 30px;
  background: #ffffff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
`;

Filter.Tabs = styled(Tabs)``;
Filter.Pane = styled(TabPane)``;

Filter.Slider = styled(Slider)``;

Filter.Select = styled(Select)`
  .ant-select-selector {
    border: none !important;
    background: transparent;
    border-bottom: 1px solid #e6e9ec !important;
    padding: 0 !important;
  }
  margin-bottom: 40px;
`;
Filter.Option = styled(Option)``;
Filter.Card = styled.div`
  min-width: 330px;
  /* filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); */
`;
Filter.Price = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #edf4fd;
  border-radius: 3px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  height: 30px;
  margin-right: 30px;
  color: #0061df;
  min-width: 100px;
`;
Filter.Title = styled.h1`
  margin-bottom: 30px;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #0d263b;
`;
Wrap.Input = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  border-bottom: 1px solid #e6e9ec;
  margin-bottom: 35px;
  padding-bottom: 8px;
  outline: none;
`;
Filter.SubTitle = styled.h3``;

export const Houses = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: fit-content;
  flex: 4;
`;

Houses.Sort = styled.div`
  display: flex;

  grid-gap: 5px;
  flex-wrap: wrap;
`;
Filter.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  width: 270px;
  background: #0061df;
  border-radius: 3px;
  margin-top: 40px;
  margin-left: 8%;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #ffffff;
`;
Filter.Search = styled(Search)`
  width: 15px;
  height: 15px;
  path {
    fill: #fff;
  }
  margin-right: 10px;
`;

Filter.Refresh = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  cursor: pointer;
`;

Filter.Return = styled(Return)`
  width: 15px;
  height: 15px;
  margin-right: 8px;
`;
